export const ERROR_CODES = [
    // Validation (400)
    "validation_failed",
    "malformed_body",
    "missing_idempotency_key",
    "tenant_required",
    "branch_required",
    "lease_required",
    "invalid_idempotency_key",
    "unknown_filter_field",
    "unsupported_media_type",
    "pagination_invalid_cursor",
    "tenant_type_mismatch",
    "user_not_tenant_kind",
    "document_tier_mismatch",
    // Field-level
    "required",
    "string_too_short",
    "string_too_long",
    "enum_invalid",
    "email_invalid",
    "phone_invalid",
    "cpr_invalid",
    "iban_invalid",
    "ulid_prefix_invalid",
    "money_negative",
    "money_currency_mismatch",
    "date_in_past",
    "date_in_future",
    "array_min_items",
    "array_max_items",
    // Authentication (401)
    "unauthorized",
    "token_expired",
    "invalid_credentials",
    "mfa_required",
    "mfa_token_expired",
    "invalid_mfa_code",
    "mfa_too_many_attempts",
    "refresh_token_invalid",
    "refresh_token_reuse_detected",
    "otp_expired",
    "invalid_otp_code",
    "reset_token_invalid",
    "reset_token_expired",
    "reset_token_used",
    "account_locked",
    "user_suspended",
    // Authorisation (403)
    "account_inactive",
    "permission_denied",
    "scope_denied",
    "tenant_access_denied",
    "step_up_required",
    "product_access_denied",
    "organization_access_denied",
    "two_person_rule_violation",
    "amount_exceeds_user_limit",
    "geofence_violation",
    "forbidden_permission",
    "forbidden_resource_scope",
    // Not found (404 / 410)
    "resource_not_found",
    "lease_not_found",
    "invoice_not_found",
    "tenant_not_found",
    "vendor_not_found",
    "payment_not_found",
    "work_order_not_found",
    "user_not_found",
    "organization_not_found",
    "document_not_found",
    "notification_template_not_found",
    "approval_request_not_found",
    "renewal_not_found",
    "approval_not_found",
    "vendor_invoice_not_found",
    "resource_gone",
    // Generic HTTP mappings
    "bad_request",
    "forbidden",
    "conflict",
    // Conflict (409)
    "resource_in_archived_state",
    "resource_in_active_state",
    "invalid_state_transition",
    "field_not_editable",
    "resource_in_use",
    "unit_not_vacant",
    "document_quarantined",
    "pdf_not_generated",
    "approval_already_decided",
    "approval_not_pending",
    "approval_no_eligible_assignee",
    "approval_policy_not_found",
    "idempotency_conflict",
    "idempotency_in_progress",
    "concurrent_modification",
    "unique_constraint_violation",
    "assignment_already_exists",
    "lease_overlap_existing",
    "invoice_already_paid",
    "vendor_invoice_already_submitted_for_wo",
    "step_not_permitted_from_status",
    "renewal_status_incompatible",
    // Domain rules (422)
    "lease_start_in_past",
    "lease_not_active",
    "lease_cannot_terminate",
    "unit_not_vacant_confirmation_required",
    "invoice_not_belongs_to_tenant",
    "amount_does_not_match_invoice_total",
    "invoice_immutable_after_issued",
    "kyc_not_verified",
    "mfa_not_enrolled",
    "notice_period_not_met",
    "damage_above_threshold_requires_approval",
    "payroll_two_person_rule",
    "wo_completion_blocked_missing_evidence",
    "quote_above_threshold_requires_approval",
    "vendor_doc_expired",
    "over_receipt_not_approved",
    "duplicate_cpr",
    "kyc_already_verified",
    "invoice_against_uncompleted_wo",
    "offer_expired",
    "not_in_scheduled_window",
    "inspection_missing_mandatory_items",
    // Rate / quota (429)
    "rate_limited",
    "plan_quota_exceeded",
    // Payments (402)
    "payment_init_failed",
    "payment_method_invalid",
    "refund_channel_unsupported",
    "partial_refund_exceeds_paid",
    // Upstream / Integration (502/504)
    "upstream_unavailable",
    "upstream_invalid_response",
    "gateway_timeout",
    "service_unavailable",
    "integration_unauthorized",
    "integration_signature_invalid",
    "external_record_not_found",
    "nbr_filing_rejected",
    "notification_dispatch_failed",
    "template_missing",
    "template_inactive",
    "template_variables_invalid",
    "upstream_gateway_unavailable",
    "hrms_unavailable",
    "role_not_assigned",
    "oauth_exchange_failed",
    // Server (5xx)
    "internal_error",
    "scope_not_yet_implemented",
    // Lease lifecycle (Sprint 5)
    "lease_not_submittable",
    "lease_approval_pending",
    "lease_not_approvable",
    // Lease signature (Sprint 5)
    "lease_signature_request_not_found",
    "lease_already_signed",
    "lease_signature_expired",
    "lease_signer_mismatch",
    "lease_invalid_transition",
    "tenant_has_no_portal_account",
    // Co-tenant (Sprint 5)
    "lease_co_tenant_invite_not_found",
    "lease_co_tenant_invite_expired",
    "lease_co_tenant_already_accepted",
    // Amendment (Sprint 5)
    "lease_amendment_not_found",
    // Renewal (Sprint 5)
    "lease_renewal_not_found",
    "lease_renewal_already_exists",
    "lease_renewal_not_convertible",
    // Invoice schedule (Sprint 5)
    "invoice_schedule_not_found",
    // Billing & Collections (Sprint 6)
    "invoice_not_issuable",
    "invoice_already_issued",
    "invoice_immutable",
    "invoice_not_cancellable",
    "invoice_has_payments",
    "invoice_number_exhausted",
    "payment_amount_invalid",
    "payment_overapplied",
    "payment_not_refundable",
    "payment_step_up_required",
    "credit_note_not_found",
    "credit_note_not_approvable",
    "credit_note_exceeds_outstanding",
    "credit_note_already_applied",
    "credit_note_approval_required",
    "dunning_invalid_stage",
    "bank_statement_parse_error",
    "reconciliation_no_match",
    // Finance / GL + Bank reconciliation (Sprint 7)
    "journal_unbalanced",
    "journal_not_reversible",
    "journal_already_reversed",
    "posting_rule_not_found",
    "account_not_found",
    "account_inactive_for_posting",
    "period_locked",
    "period_not_closable",
    "period_already_locked",
    "period_reopen_forbidden",
    "vat_return_not_generatable",
    "vat_return_already_filed",
    "bank_account_not_found",
    "reconciliation_ambiguous",
    // Onboarding (Sprint 11)
    "onboarding_token_invalid",
    "onboarding_email_not_verified",
    "onboarding_docs_missing",
    "onboarding_already_submitted",
    "application_not_in_reviewable_state",
    // Maintenance (Sprint 8)
    // Note: `work_order_not_found` and `vendor_not_found` live in the shared
    // "Not found (404 / 410)" block above — do not re-declare them here.
    "work_order_invalid_transition",
    "work_order_photo_required",
    "work_order_already_claimed",
    "work_order_already_closed",
    "work_order_number_exhausted",
    "work_order_rating_not_allowed",
    "vendor_inactive",
    "vendor_trade_mismatch",
    "quote_not_found",
    "quote_invalid_status",
    "quote_approval_required",
    "inspection_not_found",
    "inspection_invalid_status",
    "maintenance_schedule_not_found",
    "sla_target_not_computable",
    "pm_work_order_already_open",
    // Procurement (Sprint 12)
    "supplier_not_approved",
    "supplier_documents_invalid",
    "pr_not_approved",
    "po_not_issuable",
    "po_cancelled",
    "grn_over_receipt",
    "grn_po_not_receivable",
    "invoice_not_matched",
    "invoice_already_disputed",
    "invoice_match_failed",
    // Admin / Organizations (Sprint 13)
    "organization_slug_conflict",
    "organization_invalid_state_transition",
    // Admin / Users (Sprint 15)
    "self_action_forbidden",
    "protected_user",
    "user_email_conflict",
    "setup_token_invalid",
    // Admin / Master Data (Sprint 15)
    "system_item_immutable",
    "master_data_code_conflict",
    "master_data_not_found",
    // Payment Runs (Sprint 17)
    "payment_run_invalid_state_transition",
    "vendor_invoice_already_in_run",
    "payment_run_not_found",
    // Webhooks (Sprint 17)
    "webhook_subscription_not_found",
    // FixFlow internal realignment — technician assignment
    "technician_not_found",
    "technician_wrong_department",
    // FixFlow Phase-2 — triage department derivation
    "category_not_found",
    // FixFlow Phase-3 — asset management
    "asset_not_found",
    "asset_retired",
    "asset_property_mismatch",
    "asset_already_disposed",
    "dispose_remark_required",
    // Asset taxonomy (Phase 1) — group → sub-category → brand
    "asset_category_not_found",
    "asset_group_not_found",
    "asset_subcategory_not_found",
    "asset_brand_not_found",
    "duplicate_taxonomy_name",
    "subcategory_requires_group",
    "subcategory_group_mismatch",
    // Asset bulk create (Phase 2)
    "bulk_allocation_empty",
    "bulk_quantity_invalid",
    "bulk_limit_exceeded",
    // Asset lifecycle — assignment, verification audits, AMC
    "invalid_assignee",
    "not_assigned",
    "asset_verification_not_found",
    "asset_verification_invalid_state",
    "asset_verification_incomplete",
    "asset_verification_item_not_found",
    // Verification core (Phase 4)
    "verification_photo_required",
    "verification_not_auditable",
    "not_audited_reason_required",
    "replacement_request_not_found",
    "replacement_invalid_state",
    "replacement_item_not_marked",
    "amc_contract_not_found",
    "amc_vendor_required",
    // FixFlow Phase-5 — complaint workflow + config
    "work_order_already_merged",
    "work_order_merge_into_self",
    "work_order_merge_target_mismatch",
    "work_order_not_reschedulable",
    "reschedule_date_invalid",
    "recategorize_category_invalid",
    "high_value_requires_l3",
    "assessment_incomplete",
    "self_approval_forbidden",
    "customer_cancel_too_late",
    "urgent_downgrade_reason_required",
    "category_code_exists",
    "category_in_use",
    "department_code_exists",
    "department_in_use",
    // FixFlow Phase-8 — inventory
    "inventory_item_not_found",
    "inventory_code_exists",
    "stock_adjustment_invalid",
    // FixFlow Phase-9 — collective case
    "collective_case_not_found",
    "collective_case_invalid_member",
    // FixFlow — CustomerProperty assignment (assign / vacate / reassign)
    "property_not_found",
    "invalid_move_out_date",
    "duplicate_active_assignment",
    "customer_property_not_found",
    // FixFlow — Schedule: unit required when assetIds are pinned
    "unit_required",
    // FixFlow Phase-7 — notification composer / broadcast
    "notification_empty_audience",
    // FixFlow Phase-8 — customer asset-assignment acceptance
    "asset_acceptance_ack_required",
];
const ERROR_CODE_SET = new Set(ERROR_CODES);
export function isErrorCode(value) {
    return typeof value === "string" && ERROR_CODE_SET.has(value);
}
//# sourceMappingURL=codes.js.map